export const isClientRuntime = (): boolean => typeof window !== 'undefined';
